import { useState } from "react";
import { api } from "../services/api";

export function useRemoveUser({
  schoolId,
  token,
  onSuccess,
}: {
  schoolId: string;
  token: string;
  onSuccess?: () => void;
}) {
  const [isRemoving, setIsRemoving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const removeUser = async (userId: string) => {
    if (!schoolId || !token) return;
    setIsRemoving(true);
    setError(null);
    try {
      await api.users.removeFromSchool(userId, schoolId, token);
      if (onSuccess) onSuccess();
    } catch (err: any) {
      setError(err?.message || "Failed to remove user");
    } finally {
      setIsRemoving(false);
    }
  };

  return { removeUser, isRemoving, error };
}
